import { IS_ADMIN_ROLE, IS_CUSTOMER_ROLE, IS_DISTRIBUTOR_ROLE } from "@utils/user_roles.js";

export const hasAdminRole = (role) => {
	return role.id === IS_ADMIN_ROLE || role.parent_id === IS_ADMIN_ROLE;
};

export const hasCustomerRole = (role) => {
	return role.id === IS_CUSTOMER_ROLE || role.parent_id === IS_CUSTOMER_ROLE;
};

export const hasDistributorAdminRole = (role) => {
	return role.id === IS_DISTRIBUTOR_ROLE;
};
